module.exports = __webpack_public_path__ + "img/answer_card.fa20f4bc.jpg";